import type {ReactNode} from 'react'
import {useTranslation} from 'react-i18next'
import {KairosMark} from '@/components/kairos-mark'
import casimiroSaludo from '@/assets/casimiro/casimiro-saludo.webp'

export function AuthShell({children}: {children: ReactNode}) {
  const {t} = useTranslation()
  return (
    <div className="flex min-h-screen bg-background">
      <div className="flex w-full flex-col border-border bg-card px-6 py-10 sm:px-10 lg:w-[30rem] lg:shrink-0 lg:border-r lg:px-14">
        <div className="flex items-center gap-2 text-foreground">
          <KairosMark />
          <span className="font-heading text-lg tracking-tight">Kairos</span>
        </div>
        <div className="flex flex-1 items-center py-10">
          <div className="w-full max-w-sm">{children}</div>
        </div>
      </div>

      <div className="relative hidden flex-1 overflow-hidden bg-ink-deep text-ink-deep-foreground lg:block">
        <div aria-hidden="true" className="cover-ruled absolute inset-0" />
        {/* `loading="lazy"`: debajo de `lg` la cubierta está oculta y el teléfono no descarga la ilustración. */}
        <img
          src={casimiroSaludo}
          alt={t('auth.casimiroAlt')}
          loading="lazy"
          decoding="async"
          className="pointer-events-none absolute right-8 bottom-0 w-[19rem] xl:right-14 xl:w-[22rem]"
        />
        <div className="relative flex h-full flex-col justify-center px-14 xl:px-20">
          <KairosMark size="lg" />
          <p className="mt-7 font-heading text-5xl tracking-tight xl:text-6xl">Kairos</p>
        </div>
      </div>
    </div>
  )
}
